import { render } from "./NewDocumentsCard.vue?vue&type=template&id=76df30ba&scoped=true"
import script from "./NewDocumentsCard.vue?vue&type=script&lang=js"
export * from "./NewDocumentsCard.vue?vue&type=script&lang=js"

import "./NewDocumentsCard.vue?vue&type=style&index=0&id=76df30ba&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76df30ba"]])

export default __exports__